import type { BriefTranslations } from "../../types/brief";

export const brief: BriefTranslations = {
  sidebar: "Lähteülesanne",
  title: "Lähteülesanne",
  subtitle: "Projekti lähteülesanne: selle failid, täiendused ja kinnitatud versioonid",
  loadFailed: "Lähteülesannet ei õnnestunud laadida",
  notAvailable: {
    title: "Lähteülesanne pole veel saadaval",
    body: "See Franklini osa on teie organisatsioonile alles kasutusele võtmisel. Palun proovige varsti uuesti.",
  },
  sections: { documents: "Dokumendid", appendix: "Täiendused" },
  actions: {
    addFiles: "Lisa faile",
    addExisting: "Lisa olemasolev",
    addAppendix: "Lisa täiendus",
    runCheck: "Käivita kontroll",
    confirmVersion: "Kinnita versioon {number}",
  },
  documents: {
    hiddenCount: "Lähteülesande faile, mida sa ei näe: {count}",
    pickerTitle: "Lisa failid lähteülesandesse",
    pickerDescription:
      "Valitud failid kopeeritakse kausta {folder}; originaalid jäävad oma kohale.",
    pickerSubmit: "Kopeeri lähteülesandesse",
    copied: "Lähteülesandesse kopeeritud: {count}",
    copyRefused: "Ei saanud kopeerida: {count}",
    copyFailed: "Faile ei õnnestunud lähteülesandesse kopeerida",
  },
  empty: {
    title: "Lähteülesannet veel pole",
    body: "Lähteülesanne on projekti nõuete dokumentide ja selle täienduste kaust. Franklin jälgib projekti edenemist ja annab teada, kui leiab lähteülesandega vastuolusid.",
    viewerBody: "Sellel projektil pole veel lähteülesannet.",
    start: "Alusta lähteülesannet",
  },
  findings: {
    resolved: "Lahendatud",
    noneResolved: "Midagi pole veel lahendatud",
    suggestions: "Franklini ettepanekud",
    noSuggestions: "Avatud ettepanekuid pole",
    page: "lk {page}",
    sheetCells: "leht {sheet} · {cells}",
    ifcElement: "element {name}",
    buildingData: "Hoone andmed",
    issueCitation: "Ülesanne #{number}",
    accept: "Lisa lähteülesandesse",
    acceptHint: "Lisab selle lähteülesandesse täiendusena",
    dismiss: "Loobu ettepanekust",
    reopen: "Ava uuesti",
    status: {
      accepted: "Lisatud lähteülesande täiendusena",
      dismissed: "Loobutud",
      resolved: "Lahendatud lähteülesande muudatusega",
    },
    showDetails: "Näita üksikasju",
    hideDetails: "Peida üksikasjad",
    sections: { found: "Mida Franklin leidis", inBrief: "Lähteülesandes", evidence: "Tõendid" },
    severity: { high: "Kõrge", medium: "Keskmine", low: "Madal", info: "Info" },
    minimise: "Minimeeri",
    showSuggestions: "Näita Franklini ettepanekuid (avatud: {count})",
    issue: {
      heading: "Soovitatud ülesanne",
      marker: "Ülesanne soovitatud",
      why: "Miks",
      assignees: "Soovitatud vastutajad",
      noAssignees: "Kontaktide lehel ei leidu sobivat inimest — vali vastutajad ülesande loomisel.",
      disciplines: "Distsipliinid",
      create: "Loo see ülesanne",
      filed: "Ülesanne #{number}",
      noLongerOnProject: "Pole enam projektis",
      linkFailed: "Ülesanne loodi, kuid seda ei õnnestunud ettepanekuga siduda",
    },
  },
  appendix: {
    placeholder: "Lähteülesande täiendus või muudatus…",
    replyPlaceholder: "Kirjuta vastus…",
    attach: "Manusta",
    send: "Saada",
    reply: "Vasta",
    replyingTo: "Vastad kasutajale {name}",
    cancelReply: "Tühista vastamine",
    edit: "Muuda",
    edited: "Muudetud",
    save: "Salvesta",
    cancel: "Loobu",
    delete: "Kustuta",
    deleteTitle: "Kas kustutada see täiendus?",
    deleteBody:
      "See eemaldatakse lähteülesandest koos vastustega. Kinnitatud versioonidesse jääb selle koopia.",
    deleted: "Täiendus kustutatud",
    none: "Täiendusi veel pole",
    franklinConfirmedBy: "Franklin · kinnitas {name}",
    briefFiles: "Lähteülesandes",
    noneInVersion: "Selles versioonis täiendusi pole.",
    createIssue: "Loo ülesanne",
    linkedIssue: "Ülesanne #{number}",
    issueLinkFailed: "Ülesanne loodi, kuid seda ei õnnestunud täiendusega siduda",
  },
  issueOrigin: {
    label: "Lähteülesande täiendus",
    open: "Ava täiendus lähteülesandes",
    suggestionLabel: "Franklini ettepanek",
    openSuggestion: "Ava Franklini ettepanek lähteülesandes",
  },
  accept: {
    title: "Lisa lähteülesande täiendusena",
    body: "Muuda Franklini ettepanekut vajadusel. See lisatakse lähteülesandesse täiendusena: autor Franklin, kinnitaja sina.",
    text: "Täiendus",
    attachments: "Manustatud dokumendid",
    removeAttachment: "Eemalda {name}",
    submit: "Lisa lähteülesandesse",
    cancel: "Loobu",
    added: "Lisatud lähteülesandesse täiendusena",
  },
  run: {
    running: "Franklin kontrollib…",
    queued: "Kontroll on järjekorras",
    trigger: {
      documentProcessed: "pärast üleslaadimist",
      briefChanged: "pärast lähteülesande muudatust",
      issueActivity: "pärast ülesande muudatust",
      buildingData: "pärast hoone andmete muudatust",
      manual: "käsitsi käivitatud",
    },
    lastRun: "Viimane kontroll {when}",
    failedTitle: "Viimane kontroll ebaõnnestus",
    never: "Pole veel kontrollitud",
    checkQueued: "Kontroll on järjekorras",
    completedToast: "Franklin lõpetas lähteülesande kontrolli",
    review: "Vaata",
    cancel: "Tühista kontroll",
    cancelled: "Kontroll tühistatud",
    emptyBrief: "Lisa enne kontrolli käivitamist lähteülesandesse dokumente",
  },
  versions: {
    label: "Versioon {number}",
    current: "Praegune",
    unconfirmedCount: "Kinnitamata muudatusi: {count}",
    upToDate: "Ajakohane",
    choose: "Versioonid",
    short: "V{number}",
    viewing: "Versioon {number}, ainult vaatamiseks",
    confirmedBy: "{name} · {date}",
    documentCount: "Faile: {count}",
    compareWithCurrent: "Võrdle versiooni {number} praeguse lähteülesandega",
    backToCurrent: "Tagasi praegusele",
    missingFiles: "Selle versiooni faile, mida enam pole: {count}",
    unconfirmedTitle: "Muudatused alates versioonist {number}",
    unconfirmedFirst: "Veel kinnitamata",
    nothingChanged: "Pärast viimast kinnitatud versiooni pole midagi muutunud",
    delete: "Kustuta versioon {number}",
    deleteTitle: "Kas kustutada versioon {number}?",
    deleteBody:
      "Eemaldatakse lähteülesande kirje, nagu see selles versioonis kinnitati. Faile ja täiendusi see ei muuda. Kustutamine jääb lähteülesande ajalukku ja numbrit {number} uuesti ei kasutata.",
    deleteConfirm: "Kustuta",
    cancel: "Loobu",
    deleted: "Versioon {number} kustutatud",
    gone: "See versioon on juba kustutatud",
  },
  history: {
    open: "Lähteülesande ajalugu",
    title: "Ajalugu",
    empty: "Ühtegi versiooni pole veel kinnitatud",
    confirmed: "Versioon {number} kinnitatud",
    deleted: "Versioon {number} kustutatud",
    view: "Vaata versiooni {number}",
    by: "{name} · {date}",
    confirmedBy: "Kinnitas {name} · {date}",
  },
  changes: {
    added: "Uus",
    revised: "Uus versioon",
    moved: "Teisaldatud",
    inside: "Sees on muudatusi",
    folderAdded: "Uus kaust",
    appendixAdded: "Uus",
    appendixEdited: "Muudetud",
    removed: "Eemaldatud: {count}",
    since: "{change} alates versioonist {number}",
  },
  diff: {
    added: "Lisatud",
    removed: "Eemaldatud",
    revised: "Uus versioon",
    moved: "Teisaldatud",
    unchanged: "Muutmata",
    appendices: "Täiendused",
    appendixAdded: "Uus täiendus",
    appendixEdited: "Muudetud täiendus",
    appendixRemoved: "Eemaldatud täiendus",
    folders: "Kaustad",
    folderAdded: "Uus kaust",
    folderRemoved: "Eemaldatud kaust",
    folderRenamed: "Ümber nimetatud",
    folderMoved: "Teisaldatud kaust",
    compareTitle: "Võrdle versioone",
    from: "Alates",
    to: "Kuni",
    showUnchanged: "Näita muutmata",
  },
  confirm: {
    title: "Kinnita versioon {number}",
    note: "Muudatuse märkus",
    notePlaceholder: "Mis muutus ja miks",
    submit: "Kinnita",
    cancel: "Loobu",
    confirmed: "Versioon {number} kinnitatud",
    nothingChanged: "Viimasest kinnitatud versioonist alates pole midagi muutunud",
    leaveTitle: "Kas kinnitad enne lahkumist versiooni {number}?",
    leaveBody:
      "Muutsid lähteülesannet. Muudatused on igal juhul salvestatud; kinnitamine salvestab need uue versioonina.",
    keepWorking: "Jätka tööd",
    leaveWithout: "Lahku kinnitamata",
  },
  dashboardCard: {
    goToBrief: "Ava lähteülesanne",
    moreSuggestions: "+{count} veel",
  },
};
